export interface ROUTES {
  HOME: string
  ABOUT: string
  PROGRAMMES: string
  IMPACT: string
  MAGAZINE: string
  TEAM: string
  GALLERY: string
  PARTNER: string
  DONATE: string
  CONTACT: string
  PRIVACY: string
  TERMS: string
  NOT_FOUND: string
}

export const ROUTES: ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  PROGRAMMES: '/programmes',
  IMPACT: '/impact',
  MAGAZINE: '/magazine',
  TEAM: '/team',
  GALLERY: '/gallery',
  PARTNER: '/partner',
  DONATE: '/donate',
  CONTACT: '/contact',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  NOT_FOUND: '*',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]

export interface NavLinkItem {
  to: string
  label: string
}
/** Primary navigation shown in the navbar and footer. */
export const NAV_LINKS: NavLinkItem[] = [
  { to: ROUTES.HOME, label: 'Home' },
  { to: ROUTES.ABOUT, label: 'About' },
  { to: ROUTES.PROGRAMMES, label: 'Programmes' },
  { to: ROUTES.IMPACT, label: 'Impact' },
  { to: ROUTES.MAGAZINE, label: 'Magazine' },
  { to: ROUTES.TEAM, label: 'Team' },
  { to: ROUTES.GALLERY, label: 'Gallery' },
  { to: ROUTES.CONTACT, label: 'Contact' },
]
